export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGIN_REQUESTED = 'LOGIN_REQUESTED';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const SIGNOUT_USER = 'SIGNOUT_USER';
export const SET_ADMIN = 'SET_ADMIN';
export const SWITCH_ADMIN = 'SWITCH_ADMIN';
